<template>
    <div class="container-new order-right-summary right-info-block" style="text-align: left;">
        <div class="order-instruction-header">
            <i class="ion-bookmark header-icon"></i>
            <h2>Nr zamówień</h2>
        </div>
        <div class="ors-time-and-date">

            <div class="col-auto col-divided" v-for="(parcel, index) in orderParts">
                <strong>{{parcel.ordNumber}}</strong><em>{{parcel.ordValue | toFixed}} zł</em>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'parcelsSummaryBox',
        props: ["step", "orderParts"],
        data () {
            return {

            }
        },

        mounted: function() {

        },

        methods: {

        },

        filters: {
            toFixed: function(v) {
                console.log(v);

                if (v === 'Wpisz wartość zamówienia') {
                    return '0.00'
                }

                if (_.isEmpty(v) || v === '') {
                    return "0.00";
                }
                v = parseFloat(v);
                console.log(v);

                return v.toFixed(2);
            }
        },
    }
</script>



// WEBPACK FOOTER //
// ParcelsSummaryBox.vue?80f73de0